/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  hashtagModal selectors
 */

import { MODAL_TYPE, type State } from '@zcode/state-type'
import { compose } from 'redux'
import { selectModals, selectOpen } from './index'

export const selectHashtagModalOpen = (state: State) => selectOpen(state, MODAL_TYPE.HASHTAG)

export const selectHashtagModal = compose((state) => state?.hashtag, selectModals)

export const selectHashtagModalType = compose((state) => state?.modalType, selectHashtagModal)

export const selectHashtagModalRentReport = compose((state) => state.rentReport, selectHashtagModal)

export const selectHashtagModalMetroRentReport = compose(
  (state) => state.metroRentReport,
  selectModals
)
